/**
 * Marks a maybe value as invariant for Flow.
 *
 * Use with care since this doesn't do anything to stop code continuing with
 * a null value. This is best used with `document.body` or some other value
 * that one knows to be invariant at the time of use, but TypeScript isn't seeing
 * that.
 *
 * In each of these examples, removing the invariant call would result in errors
 * on the subsequent lines.
 *
 * Usage with `document.body`:
 * ```JavaScript
 * const {body} = document;
 * invariant(body);
 *
 * body.style.overflow = "hidden";
 * ```
 *
 * Usage in general:
 * ```JavaScript
 * const x: ?HTMLElement = getElement();
 * invariant(x);
 * x.focus();
 * ```
 */
export default <T>(value?: T | null): boolean => {
    return value != null;
};
